import { render, staticRenderFns } from "./HealthLogInputStatus.vue?vue&type=template&id=2b8ae060&scoped=true&lang=pug&"
import script from "./HealthLogInputStatus.vue?vue&type=script&lang=js&"
export * from "./HealthLogInputStatus.vue?vue&type=script&lang=js&"
import style0 from "./HealthLogInputStatus.vue?vue&type=style&index=0&id=2b8ae060&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b8ae060",
  null
  
)

/* custom blocks */
import block0 from "./HealthLogInputStatus.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports